import { KeyboardAvoidingView as NbKeyboardAvoidingView } from 'native-base';

import { addWithConfig } from '../../utils';

export const KeyboardAvoidingView = NbKeyboardAvoidingView;

export default addWithConfig(KeyboardAvoidingView);
